export class Storage {
  set(key, data) {
    if (window.sessionStorage.setItem) {
      window.sessionStorage.setItem(key, JSON.stringify(data));

      return true;
    }

    return false;
  }

  get(key) {
    var data;

    if (window.sessionStorage.getItem) {
      data = window.sessionStorage.getItem(key);
      if (data) {
        return JSON.parse(data);
      }
    }

    return false;
  }

  remove(key) {
    if (window.sessionStorage.removeItem) {
      window.sessionStorage.removeItem(key);

      return true;
    }

    return false;
  }

  clear() {
    sessionStorage.clear();
  }
}
